var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-layout-content',{attrs:{"medium":""}},[_c('core-layout-headline-and-actions',[_c('template',{slot:"headline"},[_vm._v(_vm._s(_vm.$t("create_email_template")))])],2),_c('template-settings',{attrs:{"currentType":"create"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }